import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-539019a8")

_pushScopeId("data-v-539019a8")
const _hoisted_1 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-1 center" }, " Utilisation ", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Pour augmenter votre utilisation mensuelle, veuillez contacter Digithia. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, { class: "main-card" }, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode("div", null, [
        _createVNode("p", null, " Vous avez actuellement la possibilité de créer " + _toDisplayString($setup.project.maxUsage) + " dossiers par mois. ", 1),
        _createVNode("p", null, " Votre utilisation actuelle : " + _toDisplayString($setup.currentUsage) + "/" + _toDisplayString($setup.project.maxUsage), 1),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
})